<template lang="pug">
div
  .input-group
    .form-input.c-hand.text-ellipsis(
      :class="{ 'input-sm': sm }",
      @click="open"
    ) {{ label }}
    span.input-group-addon.c-hand(:class="{ 'addon-sm': sm }", @click="clear")
      i.fa.fa-circle-o-notch.fa-spin.fa-fw(v-if="loading")
      i.fa.fa-times.fa-fw(v-else)

  .modal.modal-md(:class="{ active: active }")
    a.modal-overlay(aria-label="Fechar", @click="close")
    .modal-container
      .modal-header
        .columns
          .column
            .modal-title
              form(@submit.prevent="search")
                .form-group
                  label.form-label Modelos de Documentos
                  .columns
                    .column.col-auto
                      int.form-input.input-sm(
                        v-model="id_eq",
                        placeholder="#ID"
                      )
                    .column
                      input.form-input.input-sm(
                        type="text",
                        v-model="descricao_cont",
                        placeholder="Descrição"
                      )
                    .column.col-auto
                      button.btn.btn-link.btn-sm(type="submit")
                        btn-icon.fa-lg(name="filter")
          a.btn.btn-clear.float-right(aria-label="Fechar", @click="close")
      .modal-body
        .content
          spinner.text-center(:loading="loading")
          table.table.table-striped.table-hover.table-sm
            tbody
              tr(v-for="item in list", @click="select(item)")
                td.c-hand \#{{ item.id }} - {{ item.descricao }}
      .modal-footer
        paginator(
          :page="page",
          :pages="pages",
          @prev-page="prevPage",
          @next-page="nextPage",
          color="#599940"
        )
</template>

<script>
import pickerMixin, { vuexDefaultMapping } from "@/mixins/picker"
export default {
  mixins: [pickerMixin],
  vuex: { "consulta/docsModelos": vuexDefaultMapping },

  computed: {
    label() {
      if (!this.current) return "Selecione..."
      return `#${this.current.id} - ${this.current.descricao}`
    },

    descricao_cont: {
      get() {
        return this.query.descricao_cont
      },

      set(descricao_cont) {
        this.setQuery({ ...this.query, descricao_cont })
      },
    },

    id_eq: {
      get() {
        return this.query.id_eq
      },

      set(id_eq) {
        this.setQuery({ ...this.query, id_eq })
      },
    },
  },
}
</script>
